import React from 'react';
import { object, string } from 'prop-types';
import { filter, get, upperCase, map, size, has, flatten, groupBy, includes, orderBy, toNumber, isEqual, split, head, difference, compact, forEach, isEmpty } from 'lodash';
import moment from 'moment';
import PubSub from 'services/PubSub';
import Filters from '../src/components/sections/Resume/Filters';
import { Accordion, Text, Row, Loading, HasPermissions, NotFound, ConditionalRender, If, Container, Main, FlexContainer } from '../src/components/common';
import OrderCard from '../src/components/sections/Orders/OrderCard';
import GetPickingFeed from '../src/components/graphql/getPickingFeed';
import MediaListener from '../src/components/utils/MediaListener';
import Storage from '../src/components/utils/Storage';
import { isPluralFix, useReset } from '../src/utils/misc';
import withFirebase from '../src/hoc/withFirebase';
import GetTotalOrdersCountersByPendings from '../src/components/graphql/getTotalOrdersCountersByPendings';
import pathAlertSound from '../assets/sounds/alert_sound.mp3';
import { notification } from 'antd';
let autoRefreshInterval;

const styleNotification = {
    borderRadius: 4,
    height: 55
};

notification.config({
    placement: 'bottomLeft',
    bottom: 0,
    duration: 15,
    maxCount: 1
});

const TitleComponent = ({ title, totals }) => {
    const elements = {
        'pendientes': get(totals, 'pendingTotal', 0),
        'en picking': get(totals, 'inPickingTotal', 0),
        'por facturar': get(totals, 'forInvoiceTotal', 0)
    };

    return (
        <Row align='center'>
            <Text text={title} strong size={16} minWidth={120} />
            { map(elements, (value, key) => (
                <ConditionalRender condition={value}>
                    <div style={{ width: '1px', border: '1px solid #eaeaea', margin: '0px 10px', height: '20px' }} />
                    <Text text={`${value} ${isPluralFix(value, 'pedidos')} ${key}`} style={{ fontSize: '.75rem', color: '#848484' }} />
                </ConditionalRender>
            )) }
        </Row>
    );
};

TitleComponent.propTypes = {
    title: string,
    totals: object
};

TitleComponent.defaultProps = {
    title: 'store-name',
    totals: {}
};

class Resume extends React.Component {
    state = {
        filters: {
            dateSelected: new Date(),
            salesChannels: [],
            slas: [
                { label: 'Despacho Express', value: 'express' },
                { label: 'Retiro en Tienda', value: 'tienda' },
                { label: 'Retiro al Auto', value: 'auto' },
                { label: 'Despacho a Domicilio', value: 'domicilio' },
                { label: 'Despacho Especial', value: 'especial' },
                { label: 'Despacho Dinamico', value: 'dinamico' }
            ]
        },
        loading: true,
        filterSize: 200,
        refreshNow: false,
        pendingOrdersAlert: false,
        fetching: false
    }

    componentDidMount () {
        Storage.set('pending_new_orders', '');
        const { session, firebase } = this.props;
        const storeId = get(head(get(session, 'salesChannels', [])), 'id');
        firebase.collection('salesChannel').doc(storeId).onSnapshot(doc => {
            this.setState({ pendingOrdersAlert: get(doc.data(), 'pendingOrdersAlert') });
        });
        PubSub.dispatch('SET_CENTER_HEADER', () => this.leftHeader());
    }

    autoRefresh = () => {
        clearInterval(autoRefreshInterval);
        autoRefreshInterval = setInterval(() => {
            this.setState({ refreshNow: true }, () => this.setState({ refreshNow: false }));
        }, 60000);
    }

    componentWillUnmount () {
        PubSub.dispatch('SET_CENTER_HEADER', () => '');
    }

    leftHeader = () => {
        return (
            <FlexContainer align='center' mL={10}>
                <Text text={moment().format('LL')} size={18} />
            </FlexContainer>
        );
    }

    _getTabs = (salesChannelsSelected = []) => {
        const { session } = this.props;
        const userSaleschannels = get(session, 'salesChannels', []);
        const slas = [
            { _id: 'totals', label: 'Resumen' },
            { _id: 'dad', label: 'Despacho a Domicilio', icon: 'despachoADomicilio' },
            { _id: 'de', label: 'Retiro En tienda', icon: 'retiroEnTienda' },
            { _id: 'raa', label: 'Retiro al Auto', icon: 'retiroAlAuto' }
        ];

        const salesChannelItem = ({ id }) => ({
            id: parseInt(id),
            value: id,
            cm: id,
            slas
        });

        const stores = map(size(salesChannelsSelected)
            ? filter(userSaleschannels, ({ id }) => includes(salesChannelsSelected, id)) : userSaleschannels, salesChannelItem);
        return stores;
    }

    _getSources = () => {
        const { filters } = this.state;
        const salesChannelsSelected = get(filters, 'salesChannels', []);
        return this._getTabs(salesChannelsSelected);
    };

    _onSubmitFilters = ({ salesChannels, status, ...values }) => {
        const { filterSize } = this.state;
        this.setState({
            filterSize: filterSize === 100 ? filterSize + 1 : filterSize - 1,
            filters: {
                salesChannels: map(get(salesChannels, 'value', []), 'value'),
                status: map(flatten(map(status, 'value')), String),
                ...values
            }
        });
        useReset(value => this.setState({ fetching: value }));
    }

    _selectedDashboard = () => {
        const { filters } = this.state;
        const selectedSlaCode = upperCase(get(filters, 'sla')).replace(/\s/g, '_');
        return selectedSlaCode;
    }

    _getFilters = () => {
        const { filters, filterSize } = this.state;
        const { dateSelected } = filters;
        const sources = this._getSources();
        const range = has(dateSelected, 'init')
            ? {
                filter: 'shippingETA.init',
                init: `${moment(dateSelected.init).format('YYYY-MM-DD')} 00:00:00`,
                end: `${moment(dateSelected.end).format('YYYY-MM-DD')} 00:00:00`
            } : {
                filter: 'shippingETA.init',
                init: `${moment().format('YYYY-MM-DD')} 00:00:00`,
                end: `${moment().add(1, 'days').format('YYYY-MM-DD')} 00:00:00`
            };
        const filtersSet = [
            { field: 'salesChannel', value: map(sources, 'cm') },
            { field: 'selectedSLA', value: map(get(filters, 'slas', []), ({ value }) => value) },
            { field: 'status', value: flatten(map(get(filters, 'status', [[1, 2, 20].join('-')]), (i) => (i.split('-')))) }
        ];
        const filterSet = { filters: filtersSet, range: [range], sort: [{ field: 'creationDate', dir: 'desc' }], size: filterSize };
        return filterSet;
    }

    filterOrdersByStartTime = (orders) => filter(orders, item => moment(get(item, 'assignInfo.startTime'), 'YYYY-MM-DD HH:mm:ss') <= moment());

    _getDataBySalesChannels = (data, salesChannelId) => {
        const items = groupBy(data, 'salesChannel.name');
        return items;
    }

    _splitItemsByStatus = (items) => {
        const pendingItems = filter(items, (item) => includes(['1', '2', '20'], get(item, 'assignInfo.status.code')));
        const inPickingItems = filter(items, (item) => includes(['3', '7'], get(item, 'assignInfo.status.code')));
        const forInvoice = filter(items, (item) => includes(['4'], get(item, 'assignInfo.status.code')));

        return {
            pendingItems,
            inPickingItems,
            forInvoice,
            items: orderBy([...pendingItems, ...inPickingItems, ...forInvoice], item => moment(item.assignInfo.startTime).format('X'))
        };
    }

    renderNotification = (newOrders) => {
        if (!(size(newOrders) > 0)) return null;

        const { session, firebase } = this.props;
        const sessionSalesChannels = get(session, 'salesChannels', []);
        const storeId = get(head(sessionSalesChannels), 'id');

        firebase.collection('salesChannel').doc(storeId).onSnapshot(doc => {
            const pendingOrdersAlert = get(doc.data(), 'pendingOrdersAlert');
            const hasOneStore = size(sessionSalesChannels) === 1;

            if (hasOneStore && pendingOrdersAlert) {
                const audio = new Audio(pathAlertSound);
                audio.play();

                notification.open({
                    message: (<Row align='center'>
                        <Text text='Hay' size={12} color='#ffffff' />
                        <Text text={size(newOrders)} size={13} color='#ffffff' strong style={{ margin: '0px 4px' }} />
                        <Text text={`${isPluralFix(size(newOrders), 'nuevos')}`} strong string color='#ffffff' style={{ marginRight: 4 }} />
                        <Text text={`${isPluralFix(size(newOrders), 'pedidos')} en espera.`} color='#ffffff' />
                    </Row>),
                    style: { ...styleNotification, backgroundColor: '#1FA02E' }
                });
            }
        });
    }

    getAcordionComponent = (data, range, newOrders) => {
        const orderedSalesChannel = this._getDataBySalesChannels(data);
        const salesChannelIds = map(orderedSalesChannel, item => toNumber(get(item[0], 'salesChannel.id')));
        const queryVariables = {
            filters: {
                salesChannel: filter(salesChannelIds, value => !isNaN(value)),
                range
            },
            ts: moment().unix()
        };

        const totalTagets = {
            'pendingTotal': [1, 2, 20],
            'inPickingTotal': [3, 7],
            'forInvoiceTotal': [4]
        };

        return (
            <GetTotalOrdersCountersByPendings variables={queryVariables}>
                {({ data: { getTotalOrdersCountersByPendings }, loading }) => {
                    const result = get(getTotalOrdersCountersByPendings, 'data');

                    return map(orderedSalesChannel, (items, label) => {
                        const filtered = filter(result, ({ salesChannel }) => salesChannel === toNumber(get(items[0], 'salesChannel.id')));
                        let totalStatus = {};
                        forEach(filtered, ({ status, count }) => {
                            forEach(totalTagets, (value, index) => {
                                if (isEqual(value, status)) {
                                    totalStatus = {
                                        [index]: count,
                                        ...totalStatus
                                    };
                                }
                            });
                        });
                        return (
                            <Accordion
                                key={label}
                                title={
                                    <TitleComponent
                                        title={label}
                                        totals={totalStatus}
                                    />
                                }
                                background='#f4f4f4'
                                defaultOpened={size(get(this._splitItemsByStatus(items), 'pendingItems')) > 0}
                            >
                                <MediaListener values={[false, false, true]}>
                                    {({ currentValue }) => (
                                        <Row pT={5} pB={5} gap={10} style={currentValue ? { overflowX: 'scroll', flexWrap: 'nowrap' } : {}}>
                                            {map(get(this._splitItemsByStatus(items), 'items'), (item, key) => (
                                                <OrderCard
                                                    key={key}
                                                    data={item}
                                                    newOrders={newOrders}
                                                    cardHeaderProps={{
                                                        align: 'flex-start',
                                                        direction: 'column'
                                                    }}
                                                    pendingOrdersAlert={size(get(this.props.session, 'salesChannels')) === 1 ? this.state.pendingOrdersAlert : false}
                                                />
                                                )
                                            )}
                                        </Row>
                                    )}
                                </MediaListener>
                            </Accordion>
                        );
                    });
                }}
            </GetTotalOrdersCountersByPendings>
        );
    }

    render () {
        return (
            <HasPermissions
                to={['orders-pending-page:view']}
                otherwise={<NotFound firstTextLine='Página no encontrada' style={{ minHeight: '90vh' }} />}
            >
                <Container>
                    <Main background='F4F4F4' withFooter >
                        <HasPermissions to={['orders-pending-page:filter&search']}>
                            <MediaListener values={['40%', '100%', '100%']}>
                                {({ currentValue }) => <Filters
                                    currentValue={currentValue}
                                    onSubmitFilters={values => this._onSubmitFilters(values)}
                                />}
                            </MediaListener>
                        </HasPermissions>
                        <FlexContainer direction='column' shrink={0} grow={1} background='white' paddingHorizontal={23}>
                            <If
                                condition={!this.state.fetching}
                                then={
                                    <GetPickingFeed
                                        variables={this._getFilters()}
                                        fetchPolicy='no-cache'
                                        pollInterval={60000}
                                    >
                                        {({ data, loading, networkStatus }) => {
                                            let newOrders = [];

                                            if (!loading && size(data) > 0) {
                                                const storageOrderIds = compact(split(Storage.get('pending_new_orders'), ','));
                                                const orderIds = map(data, 'id');

                                                if (size(storageOrderIds) > 0) {
                                                    newOrders = difference(orderIds, storageOrderIds);
                                                    size(storageOrderIds) > 0 && this.renderNotification(newOrders);
                                                };

                                                Storage.set('pending_new_orders', orderIds);
                                            }

                                            return (
                                                <Loading loading={networkStatus === 6 ? false : loading}>
                                                    <If
                                                        condition={!loading && !isEmpty(data)}
                                                        then={this.getAcordionComponent(data, get(this._getFilters(), 'range'), newOrders)}
                                                        else={(
                                                            <NotFound
                                                                firstTextLine='No se encontraron resultados'
                                                                icon='cross'
                                                                iconBackgroundColor='#eaeaea'
                                                            />
                                                        )}
                                                    />
                                                </Loading>
                                            );
                                        }}
                                    </GetPickingFeed>
                                }
                            />
                        </FlexContainer>
                    </Main>
                </Container>
            </HasPermissions>
        );
    }
}

Resume.propTypes = {
    session: object,
    firebase: object
};

Resume.defaultProps = {
    session: {},
    firebase: {}
};

export default withFirebase(Resume);
